import React from 'react'
import { useEffect, useState, useRef } from 'react';
import ReadMore from '../../../components/ReadMoreText';
import useOnScreen from '../../../components/useOnScreen';
import { getSpeakers } from '../../../crud/dedicatedEvent-crud';
import SpeakerCardMinimalistic from './SpeakerCardMinimalistic'
import { sampleSpeakersData } from '../../../data/sampleEvent';
import { errorToaster } from '../../../helpers/utils';


const EventSpeakersMinimalistic = ({ eventUrl, eventData, setCurrSection, samplePage }) => {

    const [speakers, setSpeakers] = useState([]);

    const ref = useRef(null)

    const getAllSpeakers = async () => {
        try {
            const res = await getSpeakers(eventUrl);
            let speakerData = res.data.sort((a, b) => {
                return a.speaker_order - b.speaker_order
            });
            setSpeakers(speakerData);
        } catch (error) {
            errorToaster("Something went wrong while trying to get ticket, please try again later");
        }
    }

    useEffect(() => {
        if (samplePage) {
            setSpeakers(sampleSpeakersData);
        } else {
            getAllSpeakers()
        };
    }, [eventUrl])


    return (
        <>
            <section id='speakers' ref={ref}>
                <div className=''>
                    <div className='head'>
                        <h2 className='mb-2 mb-sm-2' style={{ fontSize: '20px', color: '#000' }}>{eventData?.speaker_section_title ? eventData?.speaker_section_title.toUpperCase() : 'EVENT SPEAKERS'}</h2>
                    </div>
                    {
                        eventData?.speaker_section_description &&
                        <div className='mt-1 mb-3'>
                            <div
                                dangerouslySetInnerHTML={{ __html: eventData.speaker_section_description?.replace(/(?:\r\n|\r|\n)/g, '') || '' }}
                                style={{
                                    fontFamily: "Manrope",
                                    fontSize: "14px",
                                    
                                }}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    }
                    <div className='row gap-0 mt-2'>
                        {speakers.map((speaker, i) => (
                            <div className='col-6 col-xxl-4 mb-3'>
                                <SpeakerCardMinimalistic speaker={speaker} key={`speaker-${i}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default EventSpeakersMinimalistic